import { Flex, Typography, Tabs } from '@aloft/toolkit-sui';

import { useMemo, useState } from 'react';

import { formatRevisionType } from '@aloft/toolkit-shared';
import { selectOrder } from '../../../redux/features/selectors/orderSelectors.ts';
import { useAppSelector } from '../../../redux/hooks.ts';
import { parseAppraiserInstructions } from './parseAppraiserInstructions.ts';
import { getTabContent } from './getTabContent.tsx';

export const ClientInformationSheet = () => {
  const [activeTab, setActiveTab] = useState('appraiser_notes');
  const order = useAppSelector((state) => selectOrder(state));
  const { revisionData } = order;
  const { previousRevisionsData } = order;
  const intendedUsers = order.intendedUsers || 'N/A';

  const appraiserInstructions = useMemo(() => {
    if (!order.appraiserInstructions) {
      return 'N/A';
    }
    return parseAppraiserInstructions(order.appraiserInstructions);
  }, [order.appraiserInstructions]);

  const tabOptions = useMemo(() => {
    const tabs = [{ value: 'appraiser_notes', label: 'Appraiser Notes' }];
    if (previousRevisionsData && previousRevisionsData.length > 0) {
      const previousTabs = previousRevisionsData.map((revision, index) => ({ value: `previous_revision_${index + 1}`, label: formatRevisionType(revision.revisionType) }));
      tabs.unshift(...previousTabs);
    }
    if (revisionData) {
      tabs.unshift({ value: 'current_revision', label: formatRevisionType(revisionData.revisionType) });
    }
    setActiveTab(tabs[0]?.value || 'appraiser_notes');
    return tabs;
  }, [revisionData, previousRevisionsData]);

  return (
    <Flex flexDirection="column" marginLeft="2rem" marginRight="4rem">
      <Typography variant="h1">Client Information</Typography>
      <Flex marginTop="1rem" justifyContent="space-between">
        <Typography variant="h3" color="textSecondary">
          Intended User(s)
        </Typography>
        <Typography variant="body1">{intendedUsers}</Typography>
      </Flex>
      <Flex marginTop="2rem" flexDirection="column" gap="5px">
        <Flex overflowX="auto" overflowY="hidden" marginRight="-2rem">
          <Tabs
            variant="secondary"
            tabs={tabOptions}
            activeTab={activeTab}
            setActiveTab={(tab: string) => setActiveTab(tab)}
          />
        </Flex>
        {getTabContent(activeTab, {
          appraiserInstructions,
          revisionData,
          previousRevisionsData,
        })}
      </Flex>
    </Flex>
  );
};
